export var colors = {
  render: '#99ff99',
  hook: '#ffccff',
  settings: '#E782A9',
  onload: '#ffcc99',
  store: '#ffffcc',
  red: '#ff9999',
  blue: '#9999ff',
  blue2: '#99ccff',
  blue3: '#88bbee',
  orange2: '#eebb88'
};
export var consoleLog = function consoleLog(isDev, data) {
  var _data$ref, _data$text;
  if (!isDev) {
    return;
  }
  var color = 'color:#cacaca;';
  if (data.color) {
    color = "color:".concat(data.color, ";");
  }
  var bg = 'background:#242424;';
  var style = "".concat(color).concat(bg);
  var ref = (_data$ref = data.ref) !== null && _data$ref !== void 0 ? _data$ref : '';
  var text = (_data$text = data.text) !== null && _data$text !== void 0 ? _data$text : '';
  var content = "%c[".concat(ref, "] ").concat(text);
  if (data.variable) {
    console.log("".concat(content, " %o"), style, data.variable);
  } else {
    console.log(content, style);
  }
};